// extracted by mini-css-extract-plugin
export default {"container":"rangeDatePickerExamples_container__FMslP","dot":"rangeDatePickerExamples_dot__oF2xj"};